import { render, staticRenderFns } from "./InvoicesStatsWeek.vue?vue&type=template&id=5a3932fc&"
import script from "./InvoicesStatsWeek.vue?vue&type=script&lang=js&"
export * from "./InvoicesStatsWeek.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/live/admin/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5a3932fc')) {
      api.createRecord('5a3932fc', component.options)
    } else {
      api.reload('5a3932fc', component.options)
    }
    module.hot.accept("./InvoicesStatsWeek.vue?vue&type=template&id=5a3932fc&", function () {
      api.rerender('5a3932fc', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/assets/js/components/common/dashboard/panels/accounts/InvoicesStatsWeek.vue"
export default component.exports